import IconButton from '../../Buttons/Icon/IconButton';
import IconLink from '../../Links/Icon/IconLink';
import Props from './typings';

const TwitterIcon = ({
  size = 16,
  title = 'Artfinder Twitter',
  action,
  url = 'https://twitter.com/artfinder',
  style,
}: Props) => {
  return action ? (
    <IconButton
      icon="twitter"
      onClick={action}
      title={title}
      style={{
        icon: {size: size, color: {default: style?.color.default, hover: style?.color.hover}},
      }}
      data-test-id="twitter-icon"
    />
  ) : (
    <IconLink
      data-test-id="twitter-icon"
      icon="twitter"
      href={url}
      title={title}
      style={{
        size: size,
        color: {default: style?.color.default, hover: style?.color.hover},
      }}
      target="_blank"
      className="twitter-icon"
      rel="nofollow"
    />
  );
};

export default TwitterIcon;
